import { ResolvedComponentsConfiguration } from "@zoovu/runner-browser-api";
import { ButtonPrimary } from "../partials/buttons";
import globals from "../partials/global-variables";

export default {
  container: {
    ...ButtonPrimary,
    marginLeft: "auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    [`@media (${globals.breakpoints.$xs})`]: {
      minWidth: "calc(50% - 8px)",
      order: 3,
      marginRight: 0,
    },
    "& span": {
      display: "inline-block",
    },
    "&:after": {
      content: "''",
      background: (configuration: ResolvedComponentsConfiguration): string =>
        `${globals.sprite2(configuration)} no-repeat 0 -140px`,
      width: "14px",
      height: "14px",
      display: "block",
      position: "absolute",
      right: "20px",
      top: "calc(50% - 7px)",
    },
  },
};
